// generated from 142 samples

import { z } from "zod";
import { stepGetBaseSchema } from "./stepGetBaseSchema";
import { androidPushMessageGetSchema } from "../message/androidPushMessageGetSchema";
import { iosPushMessageGetSchema } from "../message/iosPushMessageGetSchema";
import { webhookMessageGetSchema } from "../message/webhookMessageGetSchema";

export const userCentricOptimizationStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("USER_CENTRIC_OPTIMIZATION"),
  step_data: z.object({
    // format object-id: 80 (56.34%)
    brand_guideline_id: z.string(),
    combinations: z.array(z.string()),
    components: z.object({
      // undefined: 49 (34.51%), defined 93 (65.49%)
      message: z.array(z.string()).optional(),
      // undefined: 47 (33.10%), defined 95 (66.90%)
      title: z.array(z.string()).optional(),
    }),
    // null: 13 (9.15%)
    conversion_type: z.literal("c_0").nullable(),
    converted_step_id: z.null(),
    // null: 8 (5.63%)
    description: z.string().nullable(),
    // true 7 (4.93%), false 135 (95.07%)
    has_launched: z.boolean(),
    has_saved: z.literal(true),
    messages: z.object({
      messaging_actions: z.array(
        z.discriminatedUnion("message_type", [
          androidPushMessageGetSchema,
          iosPushMessageGetSchema,
          webhookMessageGetSchema,
        ])
      ),
    }),
    // null: 123 (86.62%)
    other_instructions: z.string().nullable(),
    progress: z.enum([
      "details", // 78 (54.93%)
      "summary", // 36 (25.35%)
      "variants", // 16 (11.27%)
      "message", // 7 (4.93%)
      "instructions", // 5 (3.52%)
    ]),
    // null: 1 (0.70%)
    seed_content: z
      .object({
        // undefined: 40 (28.37%), defined 101 (71.63%)
        message: z.string().optional(),
        // undefined: 40 (28.37%), defined 101 (71.63%)
        title: z.string().optional(),
      })
      .nullable(),
    // null: 39 (27.46%)
    seed_content_channel: z
      .enum([
        "ios_push", // 60 (58.25%)
        "android_push", // 43 (41.75%)
      ])
      .nullable(),
    // null: 38 (26.76%)
    seed_content_name: z.string().nullable(),
    // null: 123 (86.62%)
    seed_content_step_name: z.string().nullable(),
    // null: 21 (14.79%)
    seed_content_type: z
      .enum([
        "campaign", // 101 (83.47%)
        "canvas", // 20 (16.53%)
      ])
      .nullable(),
    // null: 40 (28.17%)
    seed_content_variant_name: z.string().nullable(),
    // null: 98 (69.01%)
    tones: z
      .array(
        z.enum([
          "Casual", // 10 (24.39%)
          "Formal", // 8 (19.51%)
          "Eye-catching", // 7 (17.07%)
          "Straightforward", // 5 (12.20%)
          "Personal", // 4 (9.76%)
          "Exciting", // 3 (7.32%)
          "Sophisticated", // 2 (4.88%)
          "Urgent", // 2 (4.88%)
          "Professional",
        ])
      )
      .nullable(),
    visible_combination_indices: z.array(z.array(z.int().min(0).max(4))),
    visible_components: z.array(
      z.object({
        name: z.enum([
          "title", // 95 (50.53%)
          "message", // 93 (49.47%)
        ]),
        values: z.array(z.string()),
      })
    ),
  }),
});
